module.exports = __webpack_public_path__ + "img/145.c317d6dd.jpg";